import { defineMessages } from 'react-intl';

export const bypassBlockMessages = defineMessages({
  bypassSearchField: {
    id: 'searchfield.search.field.bypass.headline',
    defaultMessage: 'Suche überspringen',
  },
  bypassSearchHistory: {
    id: 'searchfield.search.suggestions.history.bypass.headline',
    defaultMessage: 'Suchhistorie überspringen',
  },
  bypassSearchSuggestions: {
    id: 'searchfield.search.suggestions.terms.bypass.headline',
    defaultMessage: 'Suchvorschläge überspringen',
  },
  bypassSearchArticles: {
    id: 'searchfield.search.suggestions.articles.bypass.headline',
    defaultMessage: 'Artikelvorschläge überspringen',
  },
  bypassSearchCategories: {
    id: 'searchfield.search.suggestions.categories.bypass.headline',
    defaultMessage: 'Kategorievorschläge überspringen',
  },
});
